import {Button, FormControl, Stack, TextInput} from '@primer/react'
import {useState} from 'react'

export function ClientError() {
  const [throwError, setThrowError] = useState(false)
  const [message, setMessage] = useState('This is a client error!')

  if (throwError) {
    throw new Error(message)
  }

  return (
    <Stack direction="horizontal">
      <Stack className="m-2">
        <FormControl>
          <FormControl.Label>Custom error message</FormControl.Label>
          <TextInput value={message} onChange={e => setMessage(e.target.value)} placeholder="Enter error message" />
        </FormControl>
      </Stack>
      <Button
        className="m-2"
        onClick={() => {
          throw new Error(message)
        }}
      >
        Throw client error async
      </Button>
      <Button
        className="m-2"
        onClick={() => {
          setThrowError(true)
        }}
      >
        Throw client error in render
      </Button>
    </Stack>
  )
}

try{ ClientError.displayName ||= 'ClientError' } catch {}